import { Injectable } from '@angular/core';

import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipGeneratorContextType } from '../../../bet-generation/models';
import BetslipPickUtilsService from '../../../picks/services/betslip-pick-utils.service';
import { BetslipSummaryService } from '../../../summary/services/betslip-summary.service';
import { IContainerSummary, ILinearContainerSummaryService } from '../../../summary/services/linear/linear-container-summary.interface';
import { getBetslipPicks } from '../../../summary/utils/betslip-summary.utils';
import { ISystemSlipTypeInfo } from '../../models';
import { systemBetTypeStakeSelectorFactory } from '../../selectors';

@Injectable()
export class SystemBetTypeContainerSummaryService implements ILinearContainerSummaryService {
    private systemTypeInfo: ISystemSlipTypeInfo;

    constructor(
        private store: Store<IBetslipRootState>,
        private summaryService: BetslipSummaryService,
        private betslipPickUtils: BetslipPickUtilsService,
    ) {}

    initialize(systemTypeInfo: ISystemSlipTypeInfo): void {
        this.systemTypeInfo = systemTypeInfo;
    }

    getSummary$(): Observable<IContainerSummary> {
        const typeStake$ = this.store.select(systemBetTypeStakeSelectorFactory(this.systemTypeInfo.slipType.key));

        return this.summaryService.getSystemTypeSummary$(BetslipGeneratorContextType.Betslip, this.systemTypeInfo.slipType).pipe(
            concatLatestFrom(() => [typeStake$]),
            map(([[betslip, betslipSummary], stake]) => {
                const summary = betslipSummary.slipSummaries[0];

                const possibleWinnings = !!summary && typeof stake?.stake === 'number' ? summary.possibleWinnings : null;

                const totalOdds = summary.totalOdds;

                const hasOddsUpdate = getBetslipPicks(betslip).some((pick) => this.betslipPickUtils.compareAgainstLastPrice(pick) !== 0);

                return { possibleWinnings, totalOdds, hasOddsUpdate };
            }),
        );
    }
}
